import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid mt--6" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-md-8 row d-flex" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-12 mb-4",
  style: {"min-height":"300px","border-radius":"calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0"}
}
const _hoisted_6 = {
  class: "col-md-4 d-flex",
  style: {"min-height":"300px"}
}
const _hoisted_7 = { class: "card w-100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-fill" }, "Reading", -1)
const _hoisted_9 = { class: "d-fill" }
const _hoisted_10 = { class: "col-md-8" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, "Alarm", -1)
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "col-md-4 d-flex" }
const _hoisted_17 = { class: "card w-100" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-fill" }, "System", -1)
const _hoisted_19 = { class: "card-body d-fill" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReadingComponent = _resolveComponent("ReadingComponent")!
  const _component_MapComponent = _resolveComponent("MapComponent")!
  const _component_StatusComponent = _resolveComponent("StatusComponent")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_AlarmComponent = _resolveComponent("AlarmComponent")!
  const _component_SystemComponent = _resolveComponent("SystemComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ReadingComponent, {
                type: "advance",
                equipment: _ctx.equipment
              }, null, 8, ["equipment"])
            ]),
            (_ctx.map.center.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.map.center.length > 0)
                    ? (_openBlock(), _createBlock(_component_MapComponent, {
                        key: 0,
                        class: "mb-4",
                        style: {"min-height":"300px","border-radius":"calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0"},
                        center: _ctx.map.center,
                        equipments: [_ctx.equipment]
                      }, null, 8, ["center", "equipments"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_StatusComponent, { equipment: _ctx.equipment }, null, 8, ["equipment"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_n_button, {
                      class: "flex-fill",
                      type: "primary",
                      dashed: "",
                      size: "small",
                      onClick: _ctx.onSearchToggle
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Search ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              _createVNode(_component_AlarmComponent, {
                equipmentId: _ctx.equipment.id,
                searchMood: _ctx.searching
              }, null, 8, ["equipmentId", "searchMood"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_SystemComponent, { equipment: _ctx.equipment }, null, 8, ["equipment"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}